/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Recovery Integrity Signal™ sub-block.
 *
 * Displays 5 horizontal bars (off-days, after-hours, dependency density,
 * deep streak, follow-up carryover) plus the composite. Calm tones.
 *
 * Used inside both /sustainability/me (self) and the admin team rollup.
 */
const SUB_LABEL = {
  uninterrupted_off_days_score:        'Uninterrupted off-days',
  after_hours_density_score:           'After-hours density',
  emotional_dependency_density_score:  'Emotional dependency density',
  consecutive_deep_streak_score:       'Consecutive deep streak',
  unresolved_followup_carryover_score: 'Unresolved follow-up carryover',
};

export default function RecoveryIntegrityCard({ integrity, compact = false }) {
  if (!integrity) return null;
  return (
    <section data-testid="recovery-integrity-card"
              className="rounded-xl border border-[#EBE8E3] bg-[#FBFaf9] p-3 space-y-2">
      <header className="flex items-center justify-between">
        <p className="text-[10px] uppercase tracking-[0.16em] text-[#8A8681]">
          Recovery Integrity Signal™
        </p>
        <span data-testid="integrity-composite"
              className="text-[10px] uppercase tracking-[0.14em] tabular-nums text-[#5C5955]">
          {integrity.composite}
        </span>
      </header>
      {!compact && (
        <ul className="space-y-1.5">
          {Object.entries(SUB_LABEL).map(([k, label]) => {
            const v = integrity[k];
            return (
              <li key={k} data-testid={`integrity-sub-${k}`}
                  className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-[0.14em] text-[#8A8681] w-48 truncate">
                  {label}
                </span>
                <div className="flex-1 h-1 rounded-full bg-[#F4F2EE] overflow-hidden">
                  <div className="h-full" style={{
                    width: `${Math.min(100, v || 0)}%`,
                    background:
                      v >= 75 ? '#4A5D4E' :
                      v >= 55 ? '#7A8A8C' :
                      v >= 35 ? '#C8A368' :
                                '#A8A29E',
                  }} />
                </div>
                <span className="text-[10px] tabular-nums text-[#8A8681] w-9 text-right">
                  {v ?? '—'}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
